export default "__VITE_ASSET__fe37bcae__"